<template>
  <div
    v-bind="getThemeChatMessageLayoutProps('messenger-chat-message-layout', direction)"
    class="messenger-chat-message-layout"
    :class="[`messenger-chat-message-layout--${direction}`]"
  >
    <div class="messenger-chat-message-layout__body">
      <slot />
    </div>
    <messenger-chat-message-info
      class="messenger-chat-message-layout__info"
      :message-time="messageTime"
      :status="status"
    />
  </div>
</template>

<script lang="ts" setup>
import type { MessengerMessageStatus } from '@widgets/messenger/types/chat/message'
import MessengerChatMessageInfo from '@widgets/messenger/components/messages/MessengerChatMessageInfo.vue'
import { useWidgetTheme } from '@widgets/messenger/compositions/useWidgetTheme'

const { direction } = defineProps<{
  direction: 'incomming' | 'outcoming'
  messageTime: string // ISO, example: 2024-08-13T03:17:03+0000
  status?: MessengerMessageStatus
}>()

const { getThemeChatMessageLayoutProps } = useWidgetTheme()
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables';
@import '@/styles/mixins';

.messenger-chat-message-layout {
  @include widget-solid-bg($widget-light-color-map);
  position: relative;
  padding: 9px 14px 11px;
  border-radius: $border-radius-lg;
  background-color: $chatBubble;

  &--incomming {
    border-bottom-left-radius: 0;
  }

  &--outcoming {
    border-bottom-right-radius: 0;
  }

  &__body {
    font-size: $font-size-root;
    line-height: 20px;
    color: $emphasize;
  }

  &__info {
    position: absolute;
    right: 14px;
    bottom: 5px;
  }
}
</style>
